import React, {useState, useEffect} from "react";
import api from "../../../../api/api";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import {toast} from 'react-toastify'

const ReuseCompanySearch = ({setCmpId}) => {
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    api
      .get(`services/company/`)
      .then((response) => {
        // console.log(response.data)
        setSearchData(
          response.data.map(({ company_name: name, id }) => ({ name, id }))
        );
        // console.log(response.data[0].id)
        // setCmpId(response.data[0].id);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results)
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result)
  };

  const handleOnSelect = (item) => {
    // the item selected
    // console.log(item)
    api
      .get(`/services/company/${item.id}/`)
      .then((response) => {
        // console.log("Result",response.data)
        setCmpId(response.data.id);

        // setResults(response.data);
      })
      .catch((error) => {
        toast.error("something went wrong");
      });
  };

  const handleOnFocus = () => {
    // console.log('Focused')
  };

  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
      </>
    );
  };

  return (
    <div className="mb-3 md:w-[400px] w-[250px]">
      <ReactSearchAutocomplete
        items={searchData}
        onSearch={handleOnSearch}
        onHover={handleOnHover}
        onSelect={handleOnSelect}
        onFocus={handleOnFocus}
        autoFocus
        formatResult={formatResult}
        placeholder="Search Company ..."
      />
    </div>
  );
};

export default ReuseCompanySearch;
